import React from "react";

export const UserSignedUp = React.createContext(null);
